/* eslint-disable indent */
import React from 'react';
import Modal from 'react-modal';
import classnames from 'classnames';
import PhoneInput from '../FormComponents/PhoneInput';
import closeIcon from '../../assets/images/x_icon_black.svg';

import utils from '../../lib/utils';

import './index.scss';

Modal.setAppElement('#root');

class MigrateToWeave extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      weave_location_id: '',
      weave_phone_number: '',
      isPhoneInvalid: false,
      isPhoneBlank: false,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.MigrateToWeave = this.MigrateToWeave.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.carriers.migrateToWeaveSuccess &&
      nextProps.carriers.migrateToWeaveInProgress !==
        this.props.carriers.migrateToWeaveInProgress
    ) {
      this.props.closeBuyModal();
      this.props.clearErrorMessage();
    }
  }

  componentDidMount() {}

  handleInputChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    }, this.resetValidation);
    this.props.clearErrorMessage();
  }

  resetValidation() {
    this.setState({
      isPhoneInvalid: false,
      isPhoneBlank: false,
    });
  }

  validate() {
    const isValid = this.state.weave_phone_number && utils.isValidPhone(this.state.weave_phone_number);
    this.setState({
      isPhoneBlank: !this.state.weave_phone_number,
      isPhoneInvalid: !utils.isValidPhone(this.state.weave_phone_number),
    });
    return isValid;
  }

  MigrateToWeave() {
    const { weave_location_id, weave_phone_number } = this.state;
    const { auth, business } = this.props;
    const bz_id = business?.id || auth?.studio_id;
    const params = {
      weave_id: weave_location_id,
      weave_phone: weave_phone_number,
    };
    if (this.validate()) {
      this.props.migrateToWeave(params);
    }
  }

  render() {
    const { modelopen, closeBuyModal, carriers } = this.props;
    const { migrateToWeaveInProgress, migrateError, migrateToWeaveSuccess } = carriers;
    const { areadcode } = this.state;
    return (
      <div>
        <Modal
          isOpen={modelopen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={closeBuyModal}
          className="Modal"
          overlayClassName="Overlay"
          contentLabel="Example Modal"
        >
          <div>
            <div className="pc-modal-header">
              <div className="title">Migrate To Weave</div>
              <button className="modal-close" onClick={closeBuyModal}>
                <img src={closeIcon} />
              </button>
              <div className="modal-description">
                Please specify the weave location id and weave provisioned TrueLark specific phone number
              </div>
              <div className="input">
                <label className="label">Location Id</label>
                <div className="block-number">
                  <input
                    type="text"
                    name="weave_location_id"
                    placeholder="Enter Weave Location ID"
                    value={this.state.weave_location_id}
                    onChange={this.handleInputChange}
                  />
                </div>
              </div>
              <div className="input">
                <label className="label">Weave AI Assistant Phone Number</label>
                <div className="block-number">
                  <PhoneInput
                    placeholder=""
                    name="weave_phone_number"
                    value={this.state.weave_phone_number}
                    onChange={this.handleInputChange}
                    className={classnames({
                      'has-error':
                        this.state.isPhoneBlank || this.state.isPhoneInvalid,
                    })}
                  />
                </div>
                {!migrateToWeaveSuccess && (
                  <div className="error-message">{migrateError}</div>
                )}
              </div>
              <div className="actions">
                <button
                  className="btn btn--primary btn--lg"
                  onClick={this.MigrateToWeave}
                  disabled={migrateToWeaveInProgress || this.state.weave_location_id.length < 1 || this.state.weave_phone_number.length < 10}
                >
                  {migrateToWeaveInProgress ? 'MIGRATING...' : 'MIGRATE'}
                </button>
                <button
                  className="btn btn--secondary btn--lg"
                  onClick={closeBuyModal}
                >
                  CANCEL
                </button>
              </div>
            </div>
          </div>
          {this.props.children}
        </Modal>
      </div>
    );
  }
}

export default MigrateToWeave;
